import React from 'react'
import ReactDOM from 'react-dom'

export const PayPalButton = window.paypal.Buttons.driver('react', { React, ReactDOM })
